import React, { useMemo, useState } from 'react';
import { getMediaUrl } from '../../utils/imageUtils';

const normalizeAssets = (assets = [], mediaType = 'image') =>
  (Array.isArray(assets) ? assets : [])
    .map((asset) => {
      if (!asset) return null;
      if (typeof asset === 'string') {
        return { type: mediaType, url: asset };
      }
      const url = asset.url || asset.imageUrl || asset.thumbnailUrl || '';
      const type = asset.type || mediaType;
      if (!url) return null;
      return { ...asset, type, url };
    })
    .filter(Boolean)
    .filter((asset) => asset.type === mediaType || !asset.type);

const MediaPlaceholder = ({
  type = 'image',
  src,
  alt = 'Ágora media',
  className = '',
  fallbackAssets = [],
  autoPlay = false,
  muted = true,
  controls = false,
  loop = true,
  playsInline = true,
  onClick,
}) => {
  const candidates = useMemo(() => {
    const safeSource = src ? [{ type, url: src }] : [];
    return [...safeSource, ...normalizeAssets(fallbackAssets, type)];
  }, [src, fallbackAssets, type]);

  const [activeIndex, setActiveIndex] = useState(0);
  const [videoFailed, setVideoFailed] = useState(false);
  const activeCandidate = candidates[activeIndex] || null;
  const activeSource = candidates[activeIndex]?.url || '/images/placeholder/user-80.svg';

  const handleError = () => {
    if (type === 'video') setVideoFailed(true);
    setActiveIndex((prev) => {
      if (prev + 1 < candidates.length) return prev + 1;
      return prev;
    });
  };

  const resolveVideoFallbackImage = () => {
    const thumbnailCandidate = activeCandidate?.thumbnailUrl || activeCandidate?.poster || '';
    if (thumbnailCandidate) return thumbnailCandidate;

    const audioHint = String(activeCandidate?.title || '').toLowerCase();
    if (audioHint.includes('audio')) {
      return '/images/placeholder/audio-only.svg';
    }

    return '/images/placeholder/video-damaged.svg';
  };

  if (type === 'video') {
    if (videoFailed) {
      return (
        <img
          src={getMediaUrl(resolveVideoFallbackImage())}
          alt={alt}
          className={className}
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = '/images/placeholder/video-damaged.svg';
          }}
          onClick={onClick}
        />
      );
    }

    return (
      <video
        src={getMediaUrl(activeSource)}
        className={className}
        autoPlay={autoPlay}
        muted={muted}
        controls={controls}
        loop={loop}
        playsInline={playsInline}
        onError={handleError}
        onClick={onClick}
      />
    );
  }

  return (
    <img
      src={getMediaUrl(activeSource)}
      alt={alt}
      className={className}
      onError={handleError}
      onClick={onClick}
    />
  );
};

export default MediaPlaceholder;
